import { FilterType, ValueType } from "src/app/libs/ui/enums/fiters.enums";
import {
  IFilter
} from "src/app/libs/ui/interfaces/filters.interface";

export const HotelsFiltersMetaData: IFilter<any>[] = [
  {
    type: FilterType.Checkbox, // Assuming 'stars' is a valid type
    displayName: "Star Rating",
    id: "starRatings", // Assuming a unique identifier for this filter
    active: true,
    expanded: false,
    options: [
      // {
      //   type: FilterType.Star,
      //   displayName: "",
      //   id: "starRating", // Assuming a unique identifier for this filter
      //   defaultValue: 0, // You may want to set a default value
      //   value: 3,
      // },
      {
        name: "",
        options: [],
      },
    ],
  },

  {
    type: FilterType.Checkbox,
    displayName: "Board Type",
    id: "boardTypes", // Assuming a unique identifier for this filter
    active: true,
    expanded: false,
    options: [
      {
        name: "",
        options: [],
      },
    ],
  },

  {
    type: FilterType.Checkbox,
    displayName: "Hotel Facilities",
    id: "hotelFacilities", // Assuming a unique identifier for this filter
    active: true,
    expanded: false,
    options: [
      {
        name: "",
        options: [],
      },
    ],
  },
  {
    type: FilterType.Checkbox,
    displayName: "Room Facilities",
    id: "roomFacilities", // Assuming a unique identifier for this filter
    active: true,
    expanded: false,
    options: [
      {
        name: "",
        options: [],
      },
    ],
  },
  {
    type: FilterType.Checkbox,
    displayName: "Property Type",
    id: "propertyTypes", // Assuming a unique identifier for this filter
    active: true,
    expanded: false,
    options: [
      {
        name: "",
        options: [],
      },
    ],
  },
  {
    type: FilterType.Checkbox,
    displayName: "Bedrooms",
    id: "bedRooms", // Assuming a unique identifier for this filter
    active: true,
    expanded: false,
    options: [
      {
        name: "",
        options: [],
      },
    ],
  },
  {
    type: FilterType.Slider,
    displayName: "Rates",
    active: true,
    expanded: false,
    id: "rates", // Assuming a unique identifier for this filter
    options: [
      {
        min: {
          defaultValue: 0,
          type: ValueType.Number,
          value: null,
          id: null,
        },
        max: {
          defaultValue: 10000,
          type: ValueType.Number,
          value: null,
        },
      },
    ],
  },
  {
    type: FilterType.Slider,
    displayName: "Total Price",
    active: true,
    expanded: false,
    id: "totalPrice", // Assuming a unique identifier for this filter
    options: [
      {
        min: {
          defaultValue: 0,
          type: ValueType.Number,
          value: null,
          id: null,
        },
        max: {
          defaultValue: 10000,
          type: ValueType.Number,
          value: null,
        },
      },
    ],
  },
  {
    type: FilterType.Slider,
    displayName: "price Per Night",
    active: true,
    expanded: false,
    id: "pricePerNight", // Assuming a unique identifier for this filter
    options: [
      {
        min: {
          defaultValue: 0,
          type: ValueType.Number,
          value: null,
          id: null,
        },
        max: {
          defaultValue: 10000,
          type: ValueType.Number,
          value: null,
        },
      },
    ],
  },
];
